module.exports = __webpack_public_path__ + "img/app_06.8b3bdf1c.jpg";